<template>
  <div class="player-overlay-play" @click="togglePlay">
    <i class="fa fa-play" aria-hidden="true" v-if="!isPlaying"></i>
  </div>
</template>

<style lang="scss">
.player-overlay-play {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 40px);
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  i {
    width: 80px;
    height: 80px;
    background: rgba(0,0,0,0.5);
    border-radius: 50%;
    padding-left: 24px;
    color: rgba(255,255,255,0.6);
    font-size: 60px;
    line-height: 80px;
  }
}
</style>

<script>
export default {
  props: [
    'video'
  ],

  data () {
    return {
      isPlaying: false
    }
  },

  watch: {
    video () {
      this.video.addEventListener('play', () => {
        this.isPlaying = true
      })
      this.video.addEventListener('pause', () => {
        this.isPlaying = false
      })
    }
  },

  methods: {
    togglePlay () {
      this.video.paused ? this.video.play() : this.video.pause()
    }
  }
}
</script>



// WEBPACK FOOTER //
// OverlayPlay.vue?2b88833e